import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  IonHeader,
  IonCard,
  IonCardContent,
  IonTitle,
  IonContent,
  IonToolbar,
  IonIcon,
} from '@ionic/angular/standalone';
import { TRANSLATE_IMPORTS } from 'src/app/features/i18n/translate-imports';

@Component({
  selector: 're-community',
  templateUrl: './community.page.html',
  styleUrls: ['./community.page.scss'],
  imports: [
    IonIcon,
    IonToolbar,
    IonContent,
    IonCardContent,
    IonTitle,
    IonCard,
    IonHeader,
    RouterLink,
    ...TRANSLATE_IMPORTS,
  ],
})
export class CommunityPage {}
